export default __webpack_public_path__ + "static/media/avatar.37490e75.png";